export const SPORT_ROLES = {
    football: ['Portiere', 'Difensore', 'Centrocampista Laterale', 'Centrocampista Centrale', 'Attaccante'],
    volleyball: ['Palleggiatore', 'Schiacciatore', 'Opposto', 'Centrale', 'Libero'],
    basketball: ['Playmaker', 'Guardia', 'Ala Piccola', 'Ala Grande', 'Centro'],
    waterpolo: ['Portiere', 'Esterno', 'Difensore', 'Centroboa', 'Driver'],
    rugby: ['Avanti (Forward)', 'Tre-quarti (Back)', 'Mediano (Half-back)'],
    padel: ['Destra', 'Sinistra'],
    tennis: ['Destra', 'Sinistra']
};

export const getRoleBadge = (role, t) => {
    if (!role) return '';
    const translated = t ? t(role) : role;
    
    // Most common patterns: if 2+ words, take initials
    const words = translated.split(' ');
    if (words.length > 1) {
        return words.map(w => w.charAt(0).toUpperCase()).join('').slice(0, 2);
    }
    
    // For single word, return first char (e.g. "P", "D", "A")
    return translated.charAt(0).toUpperCase();
};

export const getSportRoles = (sport) => {
    return SPORT_ROLES[sport] || [];
};
